"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var _Shimmer = _interopRequireDefault(require("../Shimmer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SkeletonButton = function SkeletonButton(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      sx = _a.sx,
      props = (0, _tslib.__rest)(_a, ["variant", "sx"]);
  return _react.default.createElement(_Shimmer.default, (0, _tslib.__assign)({}, props, {
    sx: (0, _tslib.__assign)({
      height: '2.5em',
      width: '160px',
      marginBottom: '4px',
      variant: "skeletons." + variant + ".button"
    }, sx)
  }));
};

var _default = SkeletonButton;
exports.default = _default;